// Copyright (c) 2022 by Move Closer

import { MappingConfig } from '@movecloser/front-core'

import { AbstractSetDriver, AbstractTypeDriver, Identifier, RelatedType, SetDescription } from '../shared/related'

import { DescriptionOfFile, DescriptionOfImage } from './contracts'
import { fileAdapterMap } from './adapters'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export class FileDriver extends AbstractTypeDriver<DescriptionOfFile> {
  protected adapterMap: MappingConfig = fileAdapterMap
  protected dependencies: RelatedType[] = []
  protected key: RelatedType = FileRelatedType
}

export const FileRelatedType: RelatedType = 'file'

/**
 * @author Olga Milczek <lukasz.sitnicki@movecloser.pl>
 */
export class GalleryDriver extends AbstractSetDriver<SetDescription, DescriptionOfImage> {
  protected childType: RelatedType = FileRelatedType
  protected dependencies: RelatedType[] = [FileRelatedType]
  protected key: RelatedType = GalleryRelatedType
  protected shouldTrackLength: boolean = true

  /**
   * @inheritDoc
   */
  protected whenLengthExceeded (items: Identifier[], set:SetDescription, endPosition: number): void {
    while (endPosition > set.totalItems) {
      endPosition = endPosition - set.totalItems
      const fromStart = set.items.slice(0, endPosition)

      items.push(...fromStart)
    }
  }
}

export const GalleryRelatedType: RelatedType = 'gallery'
